module.exports = __webpack_public_path__ + "img/austria-liver-cancer-male.eb9f4cbf.png";